module.exports = __webpack_public_path__ + "media/images/static/top/urban/bg_top-cd5a0f4c8db2681cedacf30429ef9424.png";